module.exports = __webpack_public_path__ + "img/surprised.80d7d82e.png";